package dev.terrakok.mapitan.ui.components

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp

val TRACK_POINT_SIZE: DpSize = DpSize(14.dp, 14.dp)
val TRACK_SELECTION_WIDTH: Dp = 9.dp
val TRACK_HIT_AREA_WIDTH: Dp = 14.dp
val AREA_BORDER_HIT_WIDTH: Dp = 12.dp

class MarkerPainter(
    private val color: Color = Color.Black,
    private val inset: Dp = 2.dp,
) : Painter() {
    override val intrinsicSize: Size = Size.Unspecified

    override fun DrawScope.onDraw() {
        val padding = inset.toPx()
        drawCircle(
            color = color,
            radius = size.width / 2 - padding,
            center = Offset(size.width / 2, size.height / 2)
        )
    }
}
